var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoResourceEp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.07 31.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#412878;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-resource-ep") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-paperclip",
    "data-name": "Icon awesome-paperclip",
    className: "cls-1",
    d: "M2.71,28.4a9.35,9.35,0,0,1,.06-13.23l0,0L15.94,2.07A7.16,7.16,0,0,1,26,2.07a7,7,0,0,1,0,9.83L26,12,14.55,23.34a4.77,4.77,0,0,1-6.74,0l0,0a4.63,4.63,0,0,1,.1-6.52l9-8.94a1,1,0,0,1,1.42,0l1.43,1.36a.94.94,0,0,1,0,1.35l0,0-9,9a.8.8,0,0,0,0,1.11.68.68,0,0,0,1,0l0,0L23.14,9.23a3.13,3.13,0,0,0,0-4.42h0a3.05,3.05,0,0,0-4.33,0L5.66,17.87a5.53,5.53,0,0,0-.07,7.81,5.45,5.45,0,0,0,7.71,0h0L24.08,15a1,1,0,0,1,1.42,0l1.43,1.37a1,1,0,0,1,0,1.35l0,0L16.17,28.43A9.55,9.55,0,0,1,2.71,28.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoResourceEp);
export default __webpack_public_path__ + "static/media/ico-resource-ep.07a0aec67519efe604d6601e0d766307.svg";
export { ForwardRef as ReactComponent };